export class TemplateDashboardDomainCustomerComponent implements ng.IComponentOptions {
    public templateUrl = require('./dashboard-domain-customer.html?external');
}
